import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import { validate } from '@adornis/validation/decorators.js';
import { formatCalendarDay } from '@adornis/datetime/calendarDay.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import type { Tarifgruppe } from '../../contracts/enums/Tarifgruppe.js';
import { EntityClass } from '../../db/enums/class-names.js';

@Entity()
export class BeschaeftigungsGenehmigung extends MongoEntity {
  static override _class = EntityClass.BESCHAEFTIGUNGS_GENEHMIGUNG;
  static override _collectionName = 'beschaeftigungsgenehmigungen';

  /** @deprecated old field user userID */
  @Field(type => ID)
  mitarbeiterID!: string;

  @validate(nonOptional())
  @Field(type => ID)
  userID!: string;

  @Field(type => ID)
  schulID: Maybe<string>;

  @Field(type => Date)
  beantragtAm: Maybe<Date>;

  @Field(type => Date)
  genehmigtAm: Maybe<Date>;

  @Field(type => Date)
  beantragtVon: Maybe<Date>;

  @Field(type => Date)
  befristetBis: Maybe<Date>;

  @Field(type => String)
  tarifgruppe: Maybe<Tarifgruppe>;

  @Field(type => String)
  fach: Maybe<string>;

  @Field(type => String)
  bemerkung: Maybe<string>;

  @Field(type => Date, { default: v => v ?? new Date() })
  createdAt!: Date;
}

export function exmploymentPermitToString(
  permit: NarrowedEntity<BeschaeftigungsGenehmigung, { _id: 1; beantragtVon: 1; befristetBis: 1 }>,
) {
  // canonical calendar days - rendered UTC-pinned so this matches the detail pane in every zone
  const startDate = permit.beantragtVon ? formatCalendarDay(permit.beantragtVon, 'dd.MM.yyyy') : '<Startdatum>';
  const endDate = permit.befristetBis ? formatCalendarDay(permit.befristetBis, 'dd.MM.yyyy') : '<Enddatum>';
  return `Beschäftigungsgenehmigung von ${startDate} bis ${endDate}`;
}
